import { POST } from "../APiHelper/API";

export const getWyScoutId = (fixture_id, onSuccess, onError) => {
    const data = {
        fixture_id: fixture_id,
    };

    POST(`/api/v1/games/wyscout_id`, data, onSuccess, onError);
};
